<template>
  <div class="splash-screen">
    <img
      src="@/assets/images/logo.svg"
      alt="Интерфакс"
    >
  </div>
</template>

<script setup lang="ts">
</script>

<style scoped>
.splash-screen {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;

  & img {
    height: 25%;
    max-height: 200px;
    border-radius: 15px;
    box-shadow: 0 0 15px 15px white;
    margin-top: -100px;

    animation-name: logo-appear;
    animation-duration: 1.2s;
  }
}
</style>

<style>
@keyframes logo-appear {
  from {
    opacity: 0.2;
    transform: scale(1.2);
    filter: blur(6px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}
</style>
